module.exports = __webpack_public_path__ + "static/map_green-00cbe6446a2ca09d270a86574de42dc6.png";